import { ApdmImportSkipReason } from '@euler/model/apdm';

const kLabels: Record<ApdmImportSkipReason, string> = {
  [ApdmImportSkipReason.InvalidPlate]: '车牌无法识别',
  [ApdmImportSkipReason.MissingPlate]: '没有车牌',
  [ApdmImportSkipReason.MissingServiceDate]: '没有服务日期',
  [ApdmImportSkipReason.InvalidServiceDate]: '日期无法识别',
  [ApdmImportSkipReason.MissingDocumentId]: '没有单号',
  [ApdmImportSkipReason.UnknownCompletion]: '无法判断是否完工',
  [ApdmImportSkipReason.Other]: '其他',
};

export function skipReasonLabel(reason: ApdmImportSkipReason): string {
  return kLabels[reason] ?? kLabels[ApdmImportSkipReason.Other];
}
